import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MadricContextProvider from './Context/MadricContext';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MadricContextProvider>
          <App />
        </MadricContextProvider>
      </LocalizationProvider>
    </React.StrictMode>,
);
